import { render, staticRenderFns } from "./ChartLegends.vue?vue&type=template&id=b00b5446&scoped=true&"
import script from "./ChartLegends.vue?vue&type=script&lang=js&"
export * from "./ChartLegends.vue?vue&type=script&lang=js&"
import style0 from "./ChartLegends.vue?vue&type=style&index=0&id=b00b5446&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00b5446",
  null
  
)

export default component.exports